import Vue from 'vue'

export default {
    state: {
        isNotifOpen: false
    },

    getters: {

    },

    actions: {
        toggleNotif(context) {
            context.commit('toggleNotif')
        }
    },

    mutations: {
        toggleNotif(state) {
            state.isNotifOpen = !state.isNotifOpen
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/layout.js